export interface ReportSections {
  overview: boolean;
  stats: boolean;
  topPerformers: boolean;
  posts: boolean;
}

export interface ReportScheduleDto {
  id: string;
  briefId: string;
  dayOfWeek: number;
  timeOfDay: string;
  timezone: string;
  sections: ReportSections;
  isActive: boolean;
  nextRunAt: string;
  nextRunLocal: string;
  lastRunAt: string | null;
  recipientCount: number;
  recipients: { email: string; unsubscribedAt: string | null }[];
  scheduleDescription: string;
  latestReportUrl: string | null;
}

export interface ReportScheduleInput {
  dayOfWeek: number;
  timeOfDay: string;
  timezone: string;
  recipients: string[];
  sections: ReportSections;
}

export const WEEKDAY_OPTIONS: { value: number; label: string; short: string }[] = [
  { value: 1, label: 'Monday', short: 'Mon' },
  { value: 2, label: 'Tuesday', short: 'Tue' },
  { value: 3, label: 'Wednesday', short: 'Wed' },
  { value: 4, label: 'Thursday', short: 'Thu' },
  { value: 5, label: 'Friday', short: 'Fri' },
  { value: 6, label: 'Saturday', short: 'Sat' },
  { value: 7, label: 'Sunday', short: 'Sun' },
];

export const DEFAULT_SECTIONS: ReportSections = {
  overview: true,
  stats: true,
  topPerformers: true,
  posts: true,
};
